import React, { useState, useEffect } from "react";
import DynamicBanner from "../Pages/include/DynamicBanner";
import api from "../../api";
import toast from "react-hot-toast";

export default function AlumniFeedbackForm() {
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Store answers in a simple object: { "Library": "Good", "Canteen": "Average" }
    const [answers, setAnswers] = useState({});

    const [personalData, setPersonalData] = useState({
        name: '', course: '', batch: ''
    });

    const ratingOptions = ["Average", "Good", "Excellent"];

    // Fetch Dynamic Data
    useEffect(() => {
        const fetchData = async () => {
            try {
                // Adjust URL to match your route
                const response = await api.get('/api/sitepages/academic/alumni-feedback');
                setPageData(response.data);
            } catch (err) {
                console.error(err);
                setError("Failed to load page configuration.");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    // Handle Personal Input Changes
    const handlePersonalChange = (e) => {
        setPersonalData({ ...personalData, [e.target.name]: e.target.value });
    };

    // Handle Rating Changes
    const handleRatingChange = (label, value) => {
        setAnswers(prev => ({
            ...prev,
            [label]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // 1. Check if all questions are answered
        const questions = pageData.questions || [];
        const missing = questions.filter(q => !answers[q.label]);

        if (missing.length > 0) {
            toast.error(`Please rate: ${missing[0].label}`);
            return;
        }

        // 2. Prepare Payload
        const payload = {
            ...personalData,
            answers: answers
        };

        try {
            const response = await api.post('/api/alumni-feedback/submit', payload);
            toast.success(response.data.message || "Feedback submitted!");
            e.target.reset();
            setAnswers({});
            setPersonalData({ name: '', course: '', batch: '' });
        } catch (error) {
            const msg = error.response?.data?.message || 'Submission failed.';
            toast.error(msg);
        }
    };

    if (loading) return <div className="text-center py-5">Loading...</div>;
    if (error) return <div className="text-center py-5 text-danger">{error}</div>;
    if (!pageData) return null;

    const { banner_data, form_control, questions } = pageData;

    const renderForm = () => (
        <div className="card shadow-lg">
            <div className="card-body p-4">
                <h3 className="text-center mb-4 fw-bold text-uppercase">CARE Alumni Feedback</h3>
                <form onSubmit={handleSubmit}>

                    {/* Personal Details */}
                    <div className="row mb-4">
                        <div className="col-md-4 mb-3">
                            <label className="form-label ">Name  <span className="text-danger">*</span></label>
                            <input type="text" name="name" className="form-control"
                                value={personalData.name} onChange={handlePersonalChange} required />
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="form-label ">Course  <span className="text-danger">*</span></label>
                            <input type="text" name="course" className="form-control"
                                value={personalData.course} onChange={handlePersonalChange} required />
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="form-label ">Batch <span className="text-danger">*</span></label>
                            <input type="text" name="batch" className="form-control"
                                value={personalData.batch} onChange={handlePersonalChange} required />
                        </div>
                    </div>



                    <hr className="my-4" />
                    <h5 className="mb-3 text-secondary">Please rate the following:</h5>

                    {/* DYNAMIC QUESTIONS RENDERED HERE */}
                    {questions && questions.map((q, index) => (
                        <div className="row mb-3 align-items-center border-bottom pb-2" key={q.id}>
                            <div className="col-md-6">
                                <label className="form-label mb-0 fs-5 text-dark big-label-size">
                                    {index + 1}. {q.label} <span className="text-danger">*</span>
                                </label>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex justify-content-between justify-content-md-start gap-md-4 mt-2 mt-md-0">
                                    {ratingOptions.map((option) => (
                                        <div className="form-check d-flex align-items-center" key={`${q.id}-${option}`}>
                                            <input
                                                className="form-check-input big-radio"
                                                type="radio"
                                                name={`q_${q.id}`}
                                                id={`q_${q.id}_${option}`}
                                                value={option}
                                                checked={answers[q.label] === option}
                                                onChange={() => handleRatingChange(q.label, option)}
                                                required
                                            />
                                            <label className="form-check-label big-label ms-1" htmlFor={`q_${q.id}_${option}`}>
                                                {option}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}

                    <div className="mt-4">
                        <button type="submit" className="btn btn-primary w-100 py-2 fs-5">
                            Submit Feedback
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );

    const renderDisabled = () => (
        <div className="container py-5 text-center">
            <div className="alert alert-warning p-5 shadow-sm">
                <h3>Form Closed</h3>
                <p className="lead">{form_control.disabled_message}</p>
            </div>
        </div>
    );

    return (
        <>
            {/* Page Specific CSS */}
            <style>
                {`
                    .big-radio {
                        transform: scale(1.6);
                        cursor: pointer;
                        margin-right: 8px;
                    }

                    .shadow-sm {
                        font-size: 20px !important;
                    }

                    .big-label-size {
                        font-size: 1rem !important;
                    }

                    .big-label {
                        font-size: 1rem;
                        cursor: pointer;
                        font-weight: 500;
                    }
                    /* Optional: Add hover effect for better UX */
                    .form-check:hover .big-label {
                        color: #0d6efd; 
                    }
                `}
            </style>

            <DynamicBanner
                title={banner_data.title}
                bgImage={banner_data.desktop_images}
                bgImageMobile={banner_data.mobile_images}
            />

            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        {form_control.is_active ? renderForm() : renderDisabled()}
                    </div>
                </div>
            </div>
        </>
    );
}